import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Captain } from 'anchor-shared/lib/model/entity/captain';
import { CaptainDAO } from '../../../../../../core/services/dao/captainDAO';
import { UserDAO } from '../../../../../../core/services/dao/userDAO';

@Component({
  selector: 'app-edit-address',
  templateUrl: './edit-address.component.html',
  styleUrls: ['./edit-address.component.scss'],
})
export class EditAddressComponent implements OnInit, OnDestroy {
  model: Captain;

  constructor(
    private captainDAO: CaptainDAO,
    private userDAO: UserDAO,
    private router: Router,
  ) {}

  ngOnInit() {
    const user = this.userDAO.getCurrentUser();
    this.model = user.captain;
  }

  ngOnDestroy(): void {}

  save(captain: any) {
    this.captainDAO.updateUserCaptain(captain).subscribe((result) => {
      this.router.navigate(['manage']);
    });
  }
}
